import * as React from 'react';
import { lazyInject } from '../../../services/inversify';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { IDs } from '../../../helpers/IDs';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface KontakteProps extends React.ClassAttributes<any> {
    data: any;
    standortSelected: any;
}

interface KontakteState {

}

export class Kontakte extends React.Component<KontakteProps, KontakteState> {

    constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_KONTAKTE}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_KONTAKTE)}
                    showColumnsHelp={true}
                />
            </div>
        );
    }
}
